import React from "react";
import { NavLink } from "react-router-dom";
import { Grid } from "material-ui";

import { RegularCard, Table, ItemGrid, Button, Muted } from "components";

import Reflux from 'reflux';
import InfiniteScroll from 'react-infinite-scroll-component';
import createReactClass from 'create-react-class';
import DappsStore from '../../stores/DappsStore';

import People from "@material-ui/icons/People";
import EthAlt from 'react-cryptocoins/dist/icons/ETH-alt';

const DappsRankings = createReactClass({
    mixins: [
        Reflux.connect(DappsStore, "data")
    ],
    getInitialState: function() {
        let dapps = [];
        if (typeof DappsStore.data.dapps !== 'undefined') {
            dapps = DappsStore.data.dapps;
        }
        return {
            dapps: dapps,
            currentCount: 20,
        };
    },

    componentWillMount() {
        this.updateDappsData();
    },

    updateDappsData() {
        let self = this;
        DappsStore.getDappsPromise.then(function(dapps) {
            self.setState({
                dapps: dapps,
                currentCount: 20
            });
        });
    },

    searchFilter(value) {
        return value.title.toLowerCase().indexOf(DappsStore.data.searchQuery.toLowerCase()) !== -1 ||
            value.description.toLowerCase().indexOf(DappsStore.data.searchQuery.toLowerCase()) !== -1;
    },

    getPataDifference(a, b) {
        let d;
        let style = {
            fontSize: '0.7125rem',
            color: '#777'
        }
        if (a && !b) {
            d = 100
        } else if (!a && !b) {
            d = 0;
        } else {
            d = (100 * (a - b) / b).toFixed(2);
        }
        if (d > 0) {
            style.color = '#64ba6a';
        }
        if (d < 0) {
            style.color = '#f44336';
        }
        return <b style={
            style
            }>{+d}%</b>
    },

    getItems: function(dapps) {
        return dapps.map((value, index) => (
        [
            <NavLink
            to={'/dapp/' + value.slug}
            >{ value.title }
            </NavLink>,
            <NavLink
            to={'/' + value.category + 's'}
            >
            <Button color={ DappsStore.getColorByCategory(value.category).type } size="xs" to={'/' + value.category + 's'} target="_blank" round>
            { value.category }
            </Button>
            </NavLink>,
            <div>{+value.dau.toFixed(3)}<br/>{ this.getPataDifference(value.dau, value.previous_dau)}</div>,
            <div>{+value.balance.toFixed(3)}<br/>{ this.getPataDifference(value.balance, value.previous_balance)}</div>,
            <div>{+value.volume.toFixed(3)}<br/>{ this.getPataDifference(value.volume, value.previous_volume)}</div>,
            <div>{value.tx}<br/>{ this.getPataDifference(value.tx, value.previous_tx)}</div>,
            <span>{value.users_30d}<Muted><People style={{fontSize: "15px"}}/></Muted></span>,
            <div>{value.volume_30d.toFixed(1)}<Muted><EthAlt style={{height: "15px"}}/></Muted></div>,
        ]
        ));
    },
    /*
    compareBy: function(key, sort) {
        if (sort === 'ASC') {
            return function(a, b) {
                if (a[key] < b[key]) return -1;
                if (a[key] > b[key]) return 1;
                return 0;
            };
        } else if (sort === 'DESC') {
            return function(a, b) {
                if (a[key] > b[key]) return -1;
                if (a[key] < b[key]) return 1;
                return 0;
            };
        }
    },
    */
    compareByLink: function(key, sort) {
        if (sort === 'ASC') {
            return function(a, b) {
                return a[key]['props']['children'].localeCompare(b[key]['props']['children'], 'en');
            };
        } else if (sort === 'DESC') {
            return function(a, b) {
                return -a[key]['props']['children'].localeCompare(b[key]['props']['children'], 'en');
            }
        }
    },

    compareByCategory: function(key, sort) {
        if (sort === 'ASC') {
            return function(a, b) {
                return a[key]['props']['children']['props']['children'].localeCompare(b[key]['props']['children']['props']['children'], 'en');
            };
        } else if (sort === 'DESC') {
            return function(a, b) {
                return -a[key]['props']['children']['props']['children'].localeCompare(b[key]['props']['children']['props']['children'], 'en');
            }
        }
    },

    compareByDifference: function(key, sort) {
        if (sort === 'ASC') {
            return function(a, b) {
                if (+a[key]['props']['children'][0] < +b[key]['props']['children'][0]) return -1;
                if (+a[key]['props']['children'][0] > +b[key]['props']['children'][0]) return 1;
                return 0;
            };
        } else if (sort === 'DESC') {
            return function(a, b) {
                if (+a[key]['props']['children'][0] > +b[key]['props']['children'][0]) return -1;
                if (+a[key]['props']['children'][0] < +b[key]['props']['children'][0]) return 1;
                return 0;
            };
        }
    },

    getItemsSort: function() {
        return [
            this.compareByLink,
            this.compareByCategory,
            this.compareByDifference,
            this.compareByDifference,
            this.compareByDifference,
            this.compareByDifference,
            this.compareByDifference,
            this.compareByDifference,
        ];
    },

    hasMore: function(itemsCount) {
        return itemsCount > this.state.currentCount;
    },

    fetchMoreData: function() {
        setTimeout(() => {
            this.setState({
                currentCount: this.state.currentCount + 20
            });
        }, 50)
    },

    render() {
        let dapps = this.state.dapps.filter(this.searchFilter);
        let items = this.getItems(dapps);
        let itemsSort = this.getItemsSort();
        let topItems = this.getItems(DappsStore.data.top);
        let count = items.length;
        return (
            <InfiniteScroll
            dataLength={this.state.currentCount}
            next={this.fetchMoreData}
            hasMore={this.hasMore(count)}
            loader={
            <p style={{
                textAlign: 'center'
            }}>
              <b>Loading...</b>
            </p>
            }
            refreshFunction={this.fetchMoreData}
            scrollableTarget="mainPanel"
            >
            <Grid container>
      <ItemGrid xs={12} sm={12} md={12}>
        <RegularCard
            cardTitle="DAPP RANKINGS"
            headerColor="orange"
            cardSubtitle="ÐApps are ranked by DAU (daily active users), balance, transactions"
            content={
            <Table
            tableHeaderColor="warning"
            tableHead={["Name", "Category", "DAU", "Balance", "Volume (24H)", "Transactions (24H)", "MAU", "Volume (30d)"]}
            topData={topItems}
            tableData={items}
            tableSort={itemsSort}
            limit={ this.state.currentCount }
            />
            }
            />
      </ItemGrid>
    </Grid></InfiniteScroll>);
    }
});




//export default TableSort;
export default DappsRankings;



// WEBPACK FOOTER //
// ./src/views/TableList/TableList.jsx